import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@fluentui/react-components';

/**
 * Minimal "a new version is available" affordance for the PWA (#265).
 *
 * With `registerType: 'prompt'` the new service worker precaches in the
 * background and waits. This banner lets the user apply it now (Refresh →
 * skipWaiting + reload) or dismiss it, in which case the update activates on the
 * next cold launch. It deliberately does NOT auto-reload, so a deploy can't
 * interrupt active field data capture mid-survey.
 *
 * Renders nothing until an update is actually waiting.
 */
export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: 'var(--hts-primary-navy)',
        color: 'white',
        padding: '10px 16px',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <span>A new version is available.</span>
      <Button size="small" appearance="primary" onClick={() => void updateServiceWorker(true)}>
        Refresh
      </Button>
      <Button size="small" appearance="subtle" style={{ color: 'white' }} onClick={() => setNeedRefresh(false)}>
        Later
      </Button>
    </div>
  );
}
